// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Gwrx","consentsList":"PatientConsents_consentsList__2m_c2","consentsListEmpty":"PatientConsents_consentsListEmpty__3FqJ2"};